// The resource name is used in `in-memory-database` and `service`
export enum ResourceName {
  test = 'test',
  userClerk = 'user-clerk',
  secret = 'secret',
  file = 'file',
  openai = 'openai',
  email = 'email',
  websocket = 'websocket',
  langchain = 'langchain',
  workspace = 'workspace',
  coreItem = 'core-item',
  chat = 'chat',
  notification = 'notification',
  board = 'board',
  collect = 'collect',
  api = 'api',
  autogen = 'autogen',
  saleforce = 'saleforce',
  puppeteer = 'puppeteer',
  deepgram = 'deepgram',
  resume = 'resume',
  interview = 'interview',
  referral = 'referral',
  admin = 'admin',
}
